export default {"src":"/_next/static/image/public/assets/feature-images/en/readability.e157b2a5360fc701730efdbe520832ce.svg","height":359,"width":415};